"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSafari = exports.isDesktopSafari = exports.isAndroid = exports.isIOS = exports.isIPad = exports.isIPod = exports.isIPhone = void 0;
var IPHONE_PATTERN = /iphone/i;
var IPOD_PATTERN = /ipod/i;
var IPAD_PATTERN = /ipad/i;
var ANDROID_PATTERN = /(android)/i;
var SAFARI_PATTERN = /^((?!chrome|android).)*safari/i;
var DESKTOP_SAFARI_PATTERN = /^((?!chrome|android|iphone|ipod|ipad).)*safari/i;
// There is some iPhone/iPad/iPod in Windows Phone...
// https://msdn.microsoft.com/en-us/library/hh869301(v=vs.85).aspx
var isIE = function () { return !!window.MSStream; };
var getUserAgent = function () { return window.navigator && window.navigator.userAgent; };
var isIPhone = function () { return !isIE() && IPHONE_PATTERN.test(getUserAgent()); };
exports.isIPhone = isIPhone;
var isIPod = function () { return !isIE() && IPOD_PATTERN.test(getUserAgent()); };
exports.isIPod = isIPod;
var isIPad = function () { return !isIE() && IPAD_PATTERN.test(getUserAgent()); };
exports.isIPad = isIPad;
var isIOS = function () { return isIPhone() || isIPod() || isIPad(); };
exports.isIOS = isIOS;
var isAndroid = function () { return ANDROID_PATTERN.test(getUserAgent()); };
exports.isAndroid = isAndroid;
var isDesktopSafari = function () { return DESKTOP_SAFARI_PATTERN.test(getUserAgent()); };
exports.isDesktopSafari = isDesktopSafari;
var isSafari = function () { return SAFARI_PATTERN.test(getUserAgent()); };
exports.isSafari = isSafari;
//# sourceMappingURL=device-detection.js.map